import base from '@/service/base.service'
import {cache} from 'sgm-dms-vue-menu'
import axios from 'axios'

export default {
    init(next) {
        if (process.env.NODE_ENV === 'development') {
            cache.set('brand', process.env.VUE_APP_BRAND)
            cache.set('brandAlias', process.env.VUE_APP_BRAND_ALIAS)
            axios.interceptors.request.use((config) => {
                config.headers['brand'] = cache.get('brand');
                return config;
            }, (error) => {
                return Promise.reject(error);
            });
            next();
        }
        else {
            this.getBrand(next)
        }
    },
    getBrand(next) {
        base.getAuthorityDetail().then(res=>{
            if (res.statusCode == 200 && res.data.status == '1') {
                axios.interceptors.request.use((config) => {
                    config.headers['brand'] = res.data.brand;
                    cache.set('brand', res.data.brand)
                    cache.set('brandAlias', res.data.brandAlias)
                    return config;
                }, (error) => {
                    return Promise.reject(error);
                });
                next()
            }
        })
    }
}